// Culture Index archetype → icon name + group mapping.
// Icon names map to the <Icon> component (lucide-react inline SVGs).

export const ARCHETYPE_MAP = {
  // Visionary group (A>B, A>D)
  "Daredevil":        { icon: "bolt",            group: "Visionary" },
  "Enterpriser":      { icon: "rocket",          group: "Visionary" },
  "Philosopher":      { icon: "bulb",            group: "Visionary" },
  "Trailblazer":      { icon: "flag",            group: "Visionary" },
  "Architect":        { icon: "ruler",           group: "Visionary" },
  // Research group (A>B, D>A)
  "Technical Expert": { icon: "settings",        group: "Research" },
  "Scholar":          { icon: "book",            group: "Research" },
  "Specialist":       { icon: "microscope",      group: "Research" },
  "Craftsman":        { icon: "tools",           group: "Research" },
  // Social group (A>D)
  "Persuader":        { icon: "microphone",      group: "Social" },
  "Rainmaker":        { icon: "cloud-rain",      group: "Social" },
  "Influencer":       { icon: "speakerphone",    group: "Social" },
  "Debater":          { icon: "messages",        group: "Social" },
  "Socializer":       { icon: "users",           group: "Social" },
  // Organizational group (B>A)
  "Administrator":    { icon: "clipboard-check", group: "Organizational" },
  "Coordinator":      { icon: "calendar",        group: "Organizational" },
  "Facilitator":      { icon: "shuffle",         group: "Organizational" },
  "Operator":         { icon: "sliders",         group: "Organizational" },
  "Traditionalist":   { icon: "building",        group: "Organizational" },
  "Guardian":         { icon: "shield",          group: "Organizational" },
  // Avoidant — CI flags an inconsistent/guarded response set (not a behavioral type)
  "Avoidant":         { icon: "compass",         group: "Unclassified" },
};

export function getArchetype(name) {
  return ARCHETYPE_MAP[name] || { icon: "user", group: "—" };
}

// Gas / Brake / Glue classification for team balance.
// Gas = accelerators (high A, low C) — drive pace and decisions
// Brake = stabilizers (high D, high C) — provide caution and quality
// Glue = connectors (high B) — hold the team together socially
export function classifyEngine(person) {
  const a = person.Survey_A ?? 5;
  const b = person.Survey_B ?? 5;
  const c = person.Survey_C ?? 5;
  const d = person.Survey_D ?? 5;

  // Glue takes priority when social ability is clearly high
  if (b >= 7) return "glue";

  const gasScore = (a >= 6 ? 1 : 0) + (c <= 4 ? 1 : 0);
  const brakeScore = (d >= 6 ? 1 : 0) + (c >= 6 ? 1 : 0);

  if (gasScore > brakeScore) return "gas";
  if (brakeScore > gasScore) return "brake";
  // tie-breaker: lean on autonomy
  return a >= 6 ? "gas" : "brake";
}
